// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_eiv","cls2":"RelatedWorksCard-cls2_KGL RelatedWorksCard-cls1_eiv"};